var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "cd-timeline-content cd-timeline--log-card" },
    [
      _c("div", { staticClass: "cd-timeline-content-text" }, [
        _c("div", {
          staticClass: "cd-timeline-content--staff",
          domProps: { innerHTML: _vm._s(_vm.buildContent(_vm.oneLog)) }
        }),
        _vm._v(" "),
        _c("span", { staticClass: "nowrap gray-60 fs-2" }, [
          _vm._v(
            "\n            " +
              _vm._s(
                _vm.$filters.dateFormatter(
                  _vm.oneLog.timestamp,
                  "NORMAL_DATE_TIME",
                  true
                )
              ) +
              "\n        "
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }